import { PostCard } from "./PostCard";
import { EmptyState } from "../ui/EmptyState";
import type { Post, PostImage } from "@abejon/shared";

interface PostGridProps {
  posts: (Post & { images: PostImage[] })[];
}

export function PostGrid({ posts }: PostGridProps) {
  if (posts.length === 0) {
    return (
      <EmptyState
        title="No posts yet"
        description="Photos and updates will appear here."
      />
    );
  }

  return (
    <div className="grid grid-cols-3 gap-1">
      {posts.map((post) => (
        <PostCard key={post.id} post={post} />
      ))}
    </div>
  );
}
